export default __webpack_public_path__ + "static/media/SignUp.a912670a.svg";